import axios from 'axios'
import queryString  from 'query-string';
import { API_ENDPOINT_REPORT } from '../../constants/endpoints';
import { ReportResponseModel, SearchModel } from '../../models/ReportModel';

export function getReportData(search: SearchModel) {
  return axios.get<ReportResponseModel>(`${API_ENDPOINT_REPORT}?${queryString.stringify(search, {arrayFormat: 'bracket'})}`)
}
